module.exports = __webpack_public_path__ + "img/com.codewaystudios.facedance.cb4d46bd.png";